import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

export const useJsonLd = (data) => {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json"; el.id = "page-ld"; el.text = JSON.stringify(data);
    document.getElementById("page-ld")?.remove();
    document.head.appendChild(el);
    return () => el.remove();
  }, [JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
};

const A = ({ href = "", children }) => (href.startsWith("/") ? <Link to={href} className="text-blue-600 font-semibold hover:underline">{children}</Link>
  : <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-600 font-semibold hover:underline">{children}</a>);

const C = {
  h2: (p) => <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-3" {...p} />,
  h3: (p) => <h3 className="text-lg font-bold text-slate-900 mt-6 mb-2" {...p} />,
  p: (p) => <p className="text-slate-600 leading-relaxed mb-4" {...p} />,
  ul: (p) => <ul className="list-disc pl-6 space-y-1.5 text-slate-600 mb-4" {...p} />,
  ol: (p) => <ol className="list-decimal pl-6 space-y-1.5 text-slate-600 mb-4" {...p} />,
  strong: (p) => <strong className="text-slate-900" {...p} />,
  a: ({ href, children }) => <A href={href}>{children}</A>,
  blockquote: (p) => <blockquote className="border-l-4 border-yellow-400 pl-4 italic text-slate-600 my-4" {...p} />,
};

export const Markdown = ({ children }) => <ReactMarkdown components={C}>{children || ""}</ReactMarkdown>;
